module.exports = __webpack_public_path__ + "static/18BR-20-01-4379d5a7effb28be2c575028697d7653.svg";